import { assignment } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function findAssignees({ url: { service: baseURL }, token }: IAPI) {
  return async function findAssignees(
    input: assignment.FindAssigneesInput
  ): Promise<assignment.FindAssigneesResult> {
    const url = new URL(`/assignment/assignee`, baseURL);
    for (const [key, value] of Object.entries(input)) {
      url.searchParams.set(key, value);
    }
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch {
      throw new Error('Failed to get availability status');
    }
  };
}
